export function ChatParkTarget({ setPark }: { setPark: (node: HTMLDivElement | null) => void }) {
  return (
    <div
      ref={setPark}
      aria-hidden
      className="pointer-events-none fixed top-0 h-dvh w-screen overflow-hidden"
      style={{ left: '-100vw' }}
    />
  )
}
